import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreatePaymentSystem = (params) => {
    return axios.post(`${backendHost}/api/admin/payment/create`, params);
};

export {
    postCreatePaymentSystem
}